// Shared by browser code and Node controllers, so keep this module CommonJS.

const { PATHS } = require('../AppConstants');
const { getConsulData } = require('../UtilityComponents/index');

const ACCESS_LEVELS = {
	READ: 'READ',
	WRITE: 'WRITE',
	VOID: 'VOID'
};

const ACCESS_TYPES = {
	WRITE: 'write',
	REDIRECT: 'redirect',
	READ: 'read'
};

const ACCESS_DATA_ATTRIBUTES = {
	ACCESS_TYPE: 'data-access-type',
	MODULE_KEY: 'data-module-key',
	TARGET_MODULE_KEY: 'data-target-module-key',
	ACCESS_DENIED: 'data-access-denied'
};

const ACCESS_DENIED_POPUP = {
	HEADING: 'Access Denied',
	DEFAULT_TARGET_LABEL: 'requested',
	getContent(targetLabel = 'requested') {
		return `Your user role does not have access to the ${targetLabel} section. Kindly reach out to your organization admin for support.`;
	}
};

const MODULES_DATA = getConsulData('adminPageModulesMap') || {};

const MODULE_KEYS = Object.keys(MODULES_DATA).reduce((acc, key) => {
	acc[key] = key;
	return acc;
}, {});

const PATH_TO_MODULE_KEY_MAP = {
	[PATHS.DASHBOARD]: 'DASHBOARD',
	[PATHS.ORGANIZATION_DETAILS_PAGE]: 'COMPANY_DETAILS',
	[PATHS.EMPLOYEE_PAGE]: 'EMPLOYEES',
	[PATHS.GROUPS_PAGE]: 'GROUPS',
	[PATHS.GROUPS_DETAIL_PAGE]: 'GROUPS',
	[PATHS.ROLE_ACCESS_PAGE]: 'ROLE_ACCESS',
	[PATHS.REPORT_REVAMP]: 'TRAVEL_REPORTS',
	[`${PATHS.REPORT_DETAIL_VIEW}*`]: 'TRAVEL_REPORTS',
	[PATHS.INVOICE_PAGE]: 'TRAVEL_INVOICES',
	[PATHS.WALLET_PAGE]: 'WALLET',
	[PATHS.TRIP_TAG]: 'TRIP_TAGS',
	[PATHS.TRIP_TAG_EDIT]: 'TRIP_TAGS',
	[PATHS.POLICY_PAGE]: 'TRAVEL_POLICY',
	[PATHS.TRAVEL_REQUEST_AND_BOOKING]: 'MANAGE_BOOKING',
	[PATHS.BOOKING_SUMMARY]: 'SUPPORT_REQUESTS',
	[PATHS.BUDGET_MANAGEMENT]: 'TRAVEL_BUDGET',
	[PATHS.BUDGET_MANAGEMENT_REPORT]: 'TRAVEL_BUDGET'
};

module.exports = {
	ACCESS_DATA_ATTRIBUTES,
	ACCESS_DENIED_POPUP,
	ACCESS_LEVELS,
	ACCESS_TYPES,
	PATH_TO_MODULE_KEY_MAP,
	MODULES_DATA,
	MODULE_KEYS
};
